module.exports = __webpack_public_path__ + "static/img/bike_rider.4c0da5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/bike/bike_rider.png
// module id = 590
// module chunks = 1